const settings = {
  pxperminute: 8,
  channelstripoffset: 180, // pixels
  //headerUrl: 'https://www.a1.si/sl?p_p_id=simobilresources_WAR_simobilembeddedportlet&p_p_lifecycle=2&p_p_resource_id=simobilResourcesUrl',
  // production
  headerUrl: 'https://www.a1.si/o/navigation/sl/927877',
  // test
  //headerUrl: 'https://test-webshop.a1.si/o/navigation/sl/62884',
  //'https://test-webshop.a1.si/o/navigation/sl/62884',
  //  'https://test.a1.si/sl?p_p_id=simobilresources_WAR_simobilembeddedportlet&p_p_lifecycle=2&p_p_resource_id=simobilResourcesUrlV2',
  epgUrl:
    process.env.NODE_ENV === 'production'
      ? 'https://spored.apps.ocp-test.ljdc1.hipernet.si/'
      : 'http://spored-dev:3000',
  //assetsUrl: process.env.NODE_ENV === 'production' ? 'https://static.a1.si/tibco/spored_vod' : 'https://statict.a1.si/tibco/spored_vod', // PROD/DEV
  assetsUrl: 'https://static.a1.si/tibco/spored_vod', // PROD/DEV
  //assetsUrl: 'https://statict.a1.si/tibco/spored_vod', // TEST/DEV
};

export default settings;
